/*
 * @Descripttion:
 * @version:
 * @Author: renqiang_hu
 * @Date: 2021-05-11 16:23:43
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-06-18 09:16:21
 * @FilePath: \heshan_web\src\util\websocket.js
 */
import store from '@/store'
import { Message,Notification } from 'element-ui'
import Vue from '@/main'

var url = 'wss://heshanprod.thingcom.com/ws?type=4&topic='
var ws;
var tt;
var lockReconnect = false;//避免重复连接
var clientId = localStorage.getItem("clientId")//缓存中取出客户端id

var websocket = {
  Init: function(clientId) {
    if ("WebSocket" in window) {
      console.log(ws)
      ws = new WebSocket(url + clientId);
    } else if ("MozWebSocket" in window) {
      ws = new MozWebSocket(url + clientId);
    } else {
      console.log("您的浏览器不支持 WebSocket!");
      return;
    }

    // Vue.$global.setWs(ws);
    ws.onmessage = function(e) {

      console.log("接收消息:" + e.data,ws)
      heartCheck.start()
      if(e.data=='OK'){//心跳消息不做处理
        return
      }
      let res = JSON.parse(e.data)
      let a = clientId.split(",").filter(v=>v===res.userProjectId)

      if(a.length>0){
        Notification({
          title: '提 示',
          dangerouslyUseHTMLString: true,
          duration: 0,
          message: `<div>
          <p>项目名称：${res.projectName}</p>
          <p>设备告警：${res.alarmName}</p>
          <p>数值：${res.monitorValue}</p>
          <p>空调编号：${res.devNumber}</p>
        </div>`
        });
      }

      //messageHandle(e.data)
    }

    ws.onclose = function() {
      console.log("连接已关闭")
      // Message({
      // 		message: '连接已关闭',
      // 		type: 'error',
      // });
      reconnect(clientId);
    }

    ws.onopen = function() {
      console.log("连接成功",ws)
      // Message({
      // 		message: '连接成功',
      // 		type: 'success',
      // });
      heartCheck.start();
    }

    ws.onerror = function(e) {
      console.log("数据传输发生错误");
      // Message({
      // 		message: '数据传输发生错误',
      // 		type: 'error',
      // });
      reconnect(clientId)
    }
  },
  Send:function(sender,reception,body,flag){
    let data = {
      sender:sender,
      reception:reception,
      body:body,
      flag:flag
    }
    let msg= JSON.stringify(data)
    console.log("发送消息："+msg)
    ws.send(msg)
  },
  getWebSocket(){
    return ws;
  },
  getStatus() {
    if (ws.readyState == 0) {
      return "未连接";
    } else if (ws.readyState == 1) {
      return "已连接";
    } else if (ws.readyState == 2) {
      return "连接正在关闭";
    } else if (ws.readyState == 3) {
      return "连接已关闭";
    }
  }
}

export default websocket;

//根据消息标识做不同的处理
function messageHandle(message) {
  let msg = JSON.parse(message)
  switch (msg.flag) {
    case 'command':
      console.log("指令消息类型")
      break;
    case 'inform':
      console.log("通知")
      break;
    default:
      console.log("未知消息类型")
  }
}

function reconnect(sname) {
  if(lockReconnect) {
    return;
  }
  lockReconnect = true;
  //没连接上会一直重连，设置延迟避免请求过多
  tt && clearTimeout(tt);
  tt = setTimeout(function () {
    console.log("执行断线重连...")
    websocket.Init(sname);
    lockReconnect = false;
  }, 4000);
}

//心跳检测
var heartCheck = {
  timeout: 1000 * 60 * 3,
  timeoutObj: null,
  serverTimeoutObj: null,
  start: function(){
    console.log('开始心跳检测');
    var self = this;
    this.timeoutObj && clearTimeout(this.timeoutObj);
    this.serverTimeoutObj && clearTimeout(this.serverTimeoutObj);
    this.timeoutObj = setTimeout(function(){
      //这里发送一个心跳，后端收到后，返回一个心跳消息，
      //onmessage拿到返回的心跳就说明连接正常
      console.log('心跳检测...');
      ws.send("HeartBeat:"+ clientId );
      self.serverTimeoutObj = setTimeout(function() {
        if(ws.readyState!=1){
           ws.close();
        }
        // createWebSocket();
      }, self.timeout);

    }, this.timeout)
  }
}
